import { makeObservable, observable, action } from "mobx";
import { SortItem } from "../../api/Types";
import { SortingDirection } from "../../constants/Enums";

export default class Sorter {
  sortData: Array<SortItem> = [];
  changingKey = 0;

  constructor() {
    makeObservable(this, {
      changingKey: observable,
      addSortItem: action,
      setSortData: action,
    });
  }

  setSortData(fieldName: string, direction: SortingDirection): void {
    this.sortData = [
      {
        fieldName,
        direction,
      },
    ];
    this.changingKey += 1;
  }

  addSortItem(fieldName: string, direction: SortingDirection): void {
    const foundIdx = this.sortData.findIndex((i) => i.fieldName === fieldName);

    if (foundIdx >= 0) {
      this.sortData[foundIdx].direction = direction;
    } else {
      this.sortData.push({
        fieldName,
        direction,
      });
    }
    this.changingKey += 1;
  }
}
